module.exports = __webpack_public_path__ + "media/images/experiences/chi-d42e5ed86f2f53ca71aa820892499c13.jpg";